import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Register() {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    organization: '',
    telephone: '',
    message: '',
    consent: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await axios.post('/register', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      if (response.status === 200 || response.status === 302) {
        setMessage('Registration submitted successfully!');
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          organization: '',
          telephone: '',
          message: '',
          consent: false,
        });
      }
    } catch (error) {
      setMessage('Error submitting registration. Please try again.');
      console.error('Registration error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="container max-w-2xl">
          <h1 className="text-4xl font-bold mb-8">Register</h1>
          {message && (
            <div className={`mb-6 p-4 rounded-lg ${message.includes('successfully') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
              {message}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-[#64748b] mb-2">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm text-[#64748b] mb-2">Last Name *</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm text-[#64748b] mb-2">Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm text-[#64748b] mb-2">Organization *</label>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm text-[#64748b] mb-2">Telephone</label>
              <input
                type="tel"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm text-[#64748b] mb-2">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="w-full px-4 py-3 bg-[#f8f9fc] border border-[#e2e8f0] rounded-xl text-[#0a0a0a] focus:outline-none focus:border-[#0028CD] transition-colors resize-none"
              />
            </div>
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
                required
                className="mt-1 w-4 h-4 rounded border-[#e2e8f0] bg-[#f8f9fc] text-[#0028CD] focus:ring-[#0028CD]"
              />
              <label className="text-xs text-[#64748b]">
                I agree to the processing of my personal data per the{' '}
                <a href="https://industrialdigitaltwin.org/en/privacy" target="_blank" rel="noopener noreferrer" className="text-[#0028CD] hover:underline">
                  Privacy Policy
                </a>.
              </label>
            </div>
            <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center">
              {isSubmitting ? 'Submitting...' : 'Submit Registration'}
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Register;
